/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Tkv2ReferenceBarProperty } from '../../controller/types.ts';
import { ReferenceViewID, formatReferenceViewID } from '../../modules/referenceView/index.ts';
import { DataSheet } from '../../modules/referenceView/types.ts';
import { ReferenceBarUIState } from '../types.ts';
import { clearOrder } from './actions/clearOrder.ts';

export const initialReferenceBarUIState: ReferenceBarUIState = {
  referenceViewOpen: false,
  mobileReferenceMenuOpen: false,
  properties: [],
  selectedDataSheet: null,
  __doNotUseDirectly__ActiveID: formatReferenceViewID({ type: 'subject' }),
};

const referenceBarUISlice = createSlice({
  name: 'referenceBarUI',
  initialState: initialReferenceBarUIState,
  reducers: {
    setReferenceViewOpen(state, action: PayloadAction<boolean>) {
      // clear out the datasheet if we're closing the reference view
      // this way we know that if the datasheet changed, we definitely
      // want the reference view open.
      if (!action.payload) {
        state.selectedDataSheet = null;
      }

      state.referenceViewOpen = action.payload;
    },
    setMobileReferenceMenuOpen(state, action: PayloadAction<boolean>) {
      state.mobileReferenceMenuOpen = action.payload;
    },
    setProperties(state, action: PayloadAction<Tkv2ReferenceBarProperty[]>) {
      state.properties = action.payload;
    },
    setSelectedDataSheet(state, action: PayloadAction<DataSheet | null>) {
      state.selectedDataSheet = action.payload;
    },
    setActiveID(state, action: PayloadAction<ReferenceViewID>) {
      state.__doNotUseDirectly__ActiveID = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearOrder, () => initialReferenceBarUIState);
  }
});

export const {
  setReferenceViewOpen,
  setMobileReferenceMenuOpen,
  setProperties,
  setSelectedDataSheet,
  setActiveID,
} = referenceBarUISlice.actions;

export const referenceBarUIReducer = referenceBarUISlice.reducer;
